import template from '../../templates/Article/detail.template';
import Component from '../../core/component';

export default class Detail extends Component {
  constructor(data) {
    super(template, data);
  }
}
